export const VERSION = "1.2.1";


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 72
// module chunks = 0